import React, { useState, useEffect } from 'react';
import './NavigationSidebar.css';
import Logo02 from '../assets/logos/Assertion Logo & icon-02.svg';
import Logo06 from '../assets/logos/Assertion Logo & icon-06.svg';

interface NavigationSidebarProps {
  isCollapsed: boolean;
  onToggleCollapse: () => void;
  activeItem: string;
  onItemClick: (item: string) => void;
}

interface NavItem {
  id: string;
  label: string;
  icon: React.ReactNode;
}

const NavigationSidebar: React.FC<NavigationSidebarProps> = ({
  isCollapsed,
  onToggleCollapse,
  activeItem,
  onItemClick,
}) => {
  const dataOperationsItems: NavItem[] = [
    {
      id: 'launchpad',
      label: 'Launchpad',
      icon: (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
        </svg>
      ),
    },
    {
      id: 'workflow-library',
      label: 'Workflow Library',
      icon: (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z" />
          <path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z" />
        </svg>
      ),
    },
    {
      id: 'column-mappings',
      label: 'Column Mappings',
      icon: (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <rect x="3" y="3" width="18" height="18" rx="2" ry="2" />
          <line x1="3" y1="9" x2="21" y2="9" />
          <line x1="9" y1="21" x2="9" y2="9" />
        </svg>
      ),
    },
    {
      id: 'knowledge-base',
      label: 'Knowledge Base',
      icon: (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20" />
          <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z" />
          <line x1="12" y1="7" x2="16" y2="7" />
          <line x1="12" y1="11" x2="16" y2="11" />
          <line x1="12" y1="15" x2="16" y2="15" />
        </svg>
      ),
    },
  ];


  return (
    <nav className={`navigation-sidebar ${isCollapsed ? 'collapsed' : ''}`}>
      <div className="sidebar-header">
        <img 
          src={isCollapsed ? Logo06 : Logo02} 
          alt="Assertion Logo" 
          className="sidebar-logo"
        />
      </div>
      
      <div className="sidebar-content">
        {/* Data Operations Section */}
        <div className="nav-section">
          <ul className="nav-items">
            {dataOperationsItems.map((item) => (
              <li key={item.id}>
                <button
                  className={`nav-item ${activeItem === item.id ? 'active' : ''}`}
                  onClick={() => onItemClick(item.id)}
                  title={isCollapsed ? item.label : undefined}
                >
                  <span className="nav-item-icon">{item.icon}</span>
                  {!isCollapsed && <span className="nav-item-label">{item.label}</span>}
                </button>
              </li>
            ))}
          </ul>
        </div>

      </div>
      
      <div className="sidebar-footer">
        <button 
          className="collapse-toggle"
          onClick={onToggleCollapse}
          aria-label={isCollapsed ? 'Expand sidebar' : 'Collapse sidebar'}
        >
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="2">
            {isCollapsed ? (
              <path d="M5 12L9 8L5 4" strokeLinecap="round" strokeLinejoin="round" />
            ) : (
              <path d="M11 4L7 8L11 12" strokeLinecap="round" strokeLinejoin="round" />
            )}
          </svg>
        </button>
      </div>
    </nav>
  );
};

export default NavigationSidebar;